import { render } from "./CandidateStatusDropdown.vue?vue&type=template&id=7411a4d1"
import script from "./CandidateStatusDropdown.vue?vue&type=script&lang=js"
export * from "./CandidateStatusDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__